import React from 'react'
import ReactGiphySearchbox from 'react-giphy-searchbox'

const GiphyGrid = props => {
  const { onGifClick, classes } = props
  return (
    <div className={classes.giphyPanel}>
      <ReactGiphySearchbox
        apiKey="LaIbGHZnlC4bSEF6DolnJyUfaOwOAV6D"
        onSelect={item => onGifClick(item)}
        masonryConfig={[
          { columns: 7, imageWidth: 110, gutter: 5 },
          { mq: '700px', columns: 5, imageWidth: 120, gutter: 4 },
        ]}
        poweredByGiphy={false}
        gifListHeight="450px"
        gifListWidth="100%"
        listWrapperClassName={classes.giphyListWrapper}
      />
      <div className={classes.giphyBadge}>
        <span className={classes.giphyBadgeText}>POWERED BY</span>
        <span className={classes.giphyBadgeLogo}>GIPHY</span>
      </div>
    </div>
  )
}

export default GiphyGrid
